const tabs = {
    state: {
        articleTab: 'tab-1'
    },
    mutations: {
        SET_ARTICLE_TAB(state, payload) {
            state.articleTab = payload
        }
    },
    getters: {
        articleTab: state => state.articleTab
    }
}

export default tabs